'use client';

import { Icon } from '@/src/components/ui/Icon';
import { useProfile } from '@/src/hooks/use-profile';
import { Button } from '@workspace/ui/components/button';
import React from 'react';

export const SignUpButton = ({ isBig = false }: { isBig?: boolean }) => {
  const { data: profile } = useProfile();
  const isAnonymous = profile?.type === 'anonymous';

  const handleClick = () => {
    if (isAnonymous) {
      window.location.href = '/sign-up';
    } else {
      window.location.href = '/';
    }
  };

  if (isBig) {
    return (
      <Button
        size="lg"
        className="px-6 py-3 rounded-sm bg-white text-black font-grotesk font-bold md:h-12 md:text-xl!"
        onClick={handleClick}
      >
        Press Start
        <Icon name="play" className="size-4 ml-2 text-black" />
      </Button>
    );
  }
  return (
    <Button
      size="lg"
      className="md:ml-2 ml-1 md:px-4 px-2 py-1 bg-transparent border border-white text-white font-grotesk font-bold rounded-md! hover:bg-white hover:text-black transition-colors duration-300 md:text-xl text-base md:h-13"
      onClick={handleClick}
    >
      Sign Up
    </Button>
  );
};
